import HeaderHero from "../Contact/HeaderHero";
import Message from "../Message";
import PortfolioContent from "./PortfolioContent";
import { useEffect } from "react";

function Portfolio(){
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <>
        <HeaderHero Name={'Portfolio'}/>
        <PortfolioContent/>
        <Message/>
        </>
    );
}

export default Portfolio;
